import { defineStore } from "pinia";
import axios from "axios";

export const useRequestStore = defineStore("requestStore", {
    state: () => ({
        loading: false,
        newRequestData: [],
        cancelRequestData: [],
        newRequestCount: 0,
        cancelRequestCount: 0,
        requestType: "P"
    }),
    actions: {
        async getRequests(status) {
            this.setLoading(true);
            try {
                const res = await axios.get(
                    route("api.temp.getRequests", { status })
                );
                if (res.data.new_requests) {
                    if (status === "P") {
                        this.newRequestCount = res.data.new_requests.length;
                    }
                    if (this.requestType == status) {
                        this.newRequestData = res.data.new_requests;
                    }
                }
                if (res.data.cancel_requests) {
                    if (status === "P") {
                        this.cancelRequestCount =
                            res.data.cancel_requests.length;
                    }
                    if (this.requestType == status) {
                        this.cancelRequestData = res.data.cancel_requests;
                    }
                }
            } catch (err) {
                console.log(err);
                this.setLoading(false);
            }
            this.setLoading(false);
        },
        setLoading(isLoading) {
            this.loading = isLoading;
        },
        setRequestType(requestType) {
            this.requestType = requestType;
        }
    },
});
